module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__;